import request from '@/utils/request'

// 教辅列表
export function getMaterialList (data) {
	return request.post("/pad/common/material/list", data)
}

// 根据教辅获取课时音频信息列表
export function getLessonAduioList (materialId) {
	return request.get("/pad/common/lesson/audio/list?materialId=" + materialId)
}

// 教辅答案图片列表
export function getMaterialAnswerImage (id) {
	return request.get("/pad/common/material/answer/image/list?materialId=" + id)
}

// 查询条件
export function getMaterialCondition () {
	// return request.get("/pad/common/material/condition")
	return request.get("/pad/common/material/condition/v2")
}

